var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "dialog-base",
        {
          attrs: {
            visible: _vm.visible,
            title: _vm.dialogTitle,
            size: "xl",
            "show-confirm": false,
            "cancel-text": "Đóng",
            "cancel-type": "danger",
            "use-panel": false,
            top: "4vh",
          },
          on: {
            "update:visible": function ($event) {
              _vm.visible = $event
            },
            cancel: _vm.handleClose,
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "sk-panel mb-4",
              staticStyle: { "margin-bottom": "10px" },
            },
            [
              _c(
                "div",
                {
                  staticClass: "sk-panel-head sidd-panel-head",
                  staticStyle: {
                    display: "flex",
                    "justify-content": "space-between",
                    "align-items": "center",
                    width: "100%",
                  },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "sidd-student-info",
                      staticStyle: { display: "flex", "align-items": "center" },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "sk-panel-icon sk-panel-icon--primary",
                          staticStyle: { "margin-right": "15px" },
                        },
                        [_c("i", { staticClass: "el-icon-user" })]
                      ),
                      _c("div", [
                        _c("p", { staticClass: "sk-panel-title" }, [
                          _vm._v(
                            _vm._s(_vm.studentData.studentName || "Đang tải...")
                          ),
                        ]),
                        _c("p", { staticClass: "sk-panel-subtitle" }, [
                          _vm._v("\n              Mã học sinh: "),
                          _c("strong", [
                            _vm._v(_vm._s(_vm.studentData.studentCode || "—")),
                          ]),
                          _vm._v(" — \n              Lớp: "),
                          _c("strong", [
                            _vm._v(_vm._s(_vm.studentData.className || "—")),
                          ]),
                          _vm._v(" — \n              Tổng số phiếu thu: "),
                          _c("strong", [
                            _vm._v(
                              _vm._s((_vm.studentData.invoices || []).length)
                            ),
                          ]),
                        ]),
                      ]),
                    ]
                  ),
                  _c(
                    "div",
                    {
                      staticClass: "sidd-panel-actions",
                      staticStyle: {
                        display: "flex",
                        "justify-content": "flex-end",
                      },
                    },
                    [
                      _vm.checkPermission(["tuition_excel_export_v4"])
                        ? _c(
                            "el-button",
                            {
                              attrs: {
                                type: "success",
                                size: "small",
                                icon: "el-icon-download",
                                loading: _vm.isExporting,
                                disabled:
                                  !_vm.studentData.invoices ||
                                  _vm.studentData.invoices.length === 0,
                              },
                              on: { click: _vm.handleExportExcel },
                            },
                            [_vm._v("\n            Xuất Excel\n          ")]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ]
              ),
            ]
          ),
          _c(
            "div",
            { staticClass: "sidd-kpi-grid mb-4" },
            _vm._l(_vm.kpiCards, function (card) {
              return _c(
                "div",
                { key: card.label, staticClass: "sidd-kpi-card" },
                [
                  _c(
                    "div",
                    { staticClass: "sidd-kpi-icon", class: card.iconClass },
                    [_c("i", { class: card.icon })]
                  ),
                  _c("div", { staticClass: "sidd-kpi-body" }, [
                    _c("span", { staticClass: "sidd-kpi-label" }, [
                      _vm._v(_vm._s(card.label)),
                    ]),
                    _c(
                      "strong",
                      { staticClass: "sidd-kpi-value", class: card.valueClass },
                      [_vm._v(_vm._s(card.value))]
                    ),
                  ]),
                ]
              )
            }),
            0
          ),
          _c("div", { staticClass: "sidd-table-section" }, [
            _c("div", { staticClass: "sidd-section-head mb-2" }, [
              _c("p", { staticClass: "sidd-section-title" }, [
                _c("i", { staticClass: "el-icon-document" }),
                _vm._v(" Danh sách phiếu thu chi tiết\n        "),
              ]),
            ]),
            _c(
              "div",
              { staticClass: "sidd-table-wrapper" },
              [
                _c(
                  "el-table",
                  {
                    staticClass: "sk-table sidd-main-table",
                    attrs: {
                      data: _vm.studentData.invoices || [],
                      border: "",
                      stripe: "",
                      "empty-text": "Học sinh này chưa có phiếu thu nào.",
                      "max-height": "420",
                    },
                  },
                  [
                    _c("el-table-column", {
                      attrs: {
                        type: "index",
                        label: "STT",
                        width: "50",
                        align: "center",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: { label: "Tháng", width: "95", align: "center" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function ({ row }) {
                            return [
                              _c("span", [
                                _vm._v(_vm._s(_vm.formatMonth(row))),
                              ]),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        prop: "turn",
                        label: "Đợt",
                        width: "65",
                        align: "center",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: "Phạm vi",
                        width: "105",
                        align: "center",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function ({ row }) {
                            return [
                              _c(
                                "el-tag",
                                {
                                  attrs: {
                                    type: _vm.typeTagType(row.targetType),
                                    size: "mini",
                                    effect: "light",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(_vm.typeLabel(row.targetType)) +
                                      "\n              "
                                  ),
                                ]
                              ),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        prop: "targetName",
                        label: "Lớp / Nhóm / Gói",
                        "min-width": "170",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: "Khoảng áp dụng",
                        "min-width": "180",
                        align: "center",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function ({ row }) {
                            return [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.formatDate(row.startValidityPeriod)
                                  ) +
                                    " — " +
                                    _vm._s(
                                      _vm.formatDate(row.endValidityPeriod)
                                    )
                                ),
                              ]),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: "Trạng thái",
                        width: "135",
                        align: "center",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function ({ row }) {
                            return [
                              _c(
                                "el-tag",
                                {
                                  attrs: {
                                    type: _vm.statusTagType(row.status),
                                    size: "mini",
                                    effect: "light",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(_vm.statusLabel(row.status)) +
                                      "\n              "
                                  ),
                                ]
                              ),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: "Phải thu",
                        align: "right",
                        "min-width": "130",
                        "class-name": "sidd-finance-column",
                        "label-class-name": "sidd-finance-header",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function ({ row }) {
                            return [
                              _c(
                                "span",
                                { staticClass: "sidd-money sidd-money--bold" },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("formatCurrency")(row.sumMoney)
                                    )
                                  ),
                                ]
                              ),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: "Đã thu",
                        align: "right",
                        "min-width": "130",
                        "class-name": "sidd-finance-column",
                        "label-class-name": "sidd-finance-header",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function ({ row }) {
                            return [
                              _c("span", { staticClass: "sidd-money" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("formatCurrency")(row.collectedMoney)
                                  )
                                ),
                              ]),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: "Thiếu / Thừa",
                        align: "right",
                        "min-width": "130",
                        "class-name": "sidd-finance-column",
                        "label-class-name": "sidd-finance-header",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function ({ row }) {
                            return [
                              _c(
                                "span",
                                {
                                  class:
                                    row.afterMoney > 0
                                      ? "sidd-money--positive"
                                      : "sidd-money--negative",
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        _vm._f("formatCurrency")(row.afterMoney)
                                      ) +
                                      "\n              "
                                  ),
                                ]
                              ),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: "Tác vụ",
                        width: "145",
                        align: "center",
                        fixed: "right",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function ({ row }) {
                            return [
                              _c(
                                "div",
                                { staticClass: "sidd-action-buttons" },
                                [
                                  _c(
                                    "el-tooltip",
                                    {
                                      attrs: {
                                        content: "Chi tiết / Thanh toán",
                                        placement: "top",
                                        enterable: false,
                                      },
                                    },
                                    [
                                      _vm.checkPermission([
                                        "tuition_payment_v4",
                                      ])
                                        ? _c("el-button", {
                                            attrs: {
                                              size: "mini",
                                              type: "primary",
                                              icon: "el-icon-wallet",
                                              circle: "",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.handleOpenInvoice(
                                                  row
                                                )
                                              },
                                            },
                                          })
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-tooltip",
                                    {
                                      attrs: {
                                        content: "Lịch sử thanh toán",
                                        placement: "top",
                                        enterable: false,
                                      },
                                    },
                                    [
                                      _c("el-button", {
                                        attrs: {
                                          size: "mini",
                                          type: "success",
                                          icon: "el-icon-tickets",
                                          circle: "",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.handlePaymentHistory(row)
                                          },
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-tooltip",
                                    {
                                      attrs: {
                                        content: "Lịch sử thao tác",
                                        placement: "top",
                                        enterable: false,
                                      },
                                    },
                                    [
                                      _c("el-button", {
                                        attrs: {
                                          size: "mini",
                                          type: "warning",
                                          icon: "el-icon-time",
                                          circle: "",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.handleActionHistory(row)
                                          },
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                      ]),
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
        ]
      ),
      _c("invoice-payment-dialog", {
        ref: "invoicePaymentDialog",
        on: { saved: _vm.handleInvoiceSaved },
      }),
      _c("invoice-payment-history-dialog", {
        ref: "invoicePaymentHistoryDialog",
      }),
      _c("invoice-action-history-dialog", {
        ref: "invoiceActionHistoryDialog",
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }